
var React = require("react");
var PropTypes = require("prop-types");

class CrossfadeImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      topImage: props.image,
      bottomOpacity: 0,
      bottomImage: props.image
    };
  }
  componentWillReceiveProps(newProps) {
    const oldImage = this.state.topImage;
    const newImage = newProps.image;
    if (newImage.smallUrl !== oldImage.smallUrl) {
      // Reset the component everytime we receive new prop, to
      // cancel out any animation that's still going on
      this.setState({ bottomImage: false, topImage: false }, () =>
        this.setState(
          // Opacity less than 1 takes precendence in stacking order
          { bottomImage: oldImage, topImage: newImage, bottomOpacity: 0.99 },
          () => {
            // One of the few times setTimeout does wonders, this is for
            // getting fade out transition without css keyframe
            if (!this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(
              () => this.setState({ bottomOpacity: 0 }),
              20
            );
          }
        )
      );
    }
  }
  render() {
    const { containerClass, duration, timingFunction, delay, style } = this.props;
    const { topImage, bottomOpacity, bottomImage } = this.state;
    return (
      <div className={containerClass} style={{ ...{ position: "relative", height: "100%" } }}>
        {topImage &&
          <picture>
            <source media="(min-width: 1600px)" srcSet={topImage.extraLargeUrl} />
            <source media="(min-width: 1400px)" srcSet={topImage.largeUrl} />
            <source media="(min-width: 1024px)" srcSet={topImage.mediumUrl} />
            <img src={topImage.smallUrl} alt={topImage.imageAltText || topImage.altText} loading="lazy" className="c-image-copy__image" />
          </picture>
          }   
        {bottomImage &&
          <picture
          style={{
            ...style,
            ...{
              opacity: bottomOpacity,
              transition: `opacity ${duration / 1000}s ${timingFunction} ${delay / 1000}s`
            }
          }}
          >
            <source media="(min-width: 1600px)" srcSet={bottomImage.extraLargeUrl} />
            <source media="(min-width: 1400px)" srcSet={bottomImage.largeUrl} />
            <source media="(min-width: 1024px)" srcSet={bottomImage.mediumUrl} />
            <img src={bottomImage.smallUrl} alt={bottomImage.imageAltText || bottomImage.altText} loading="lazy" className="c-image-copy__image"
            
            />
          </picture>
          }
      </div>
    );
  }
}


CrossfadeImage.propTypes = {
  image: PropTypes.object.isRequired,
  duration: PropTypes.number,
  timingFunction: PropTypes.string,
  delay: PropTypes.number,
  style: PropTypes.object,
  containerClass: PropTypes.string,
};

CrossfadeImage.defaultProps = {
  duration: 500,
  timingFunction: "ease",
  delay: 0,
  containerClass: "c-cross-fade",
};

module.exports = CrossfadeImage;


// WEBPACK FOOTER //
// ./src/components/ImageCopy/CrossFadeImage.js